import { useUser } from "@clerk/nextjs";

export function useCustomizedUser() {
  const { isSignedIn, isLoaded, user } = useUser()
  return {
    user: isLoaded ? {
      ...user,
      id: user?.externalId || user?.id, // ID that linked to our database, for migrated user the id is set to externalId
      clerk_original_id: user?.id, // Original id of the clerk
    } : null,
    isSignedIn,
    isLoaded,
  }
}
